import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { CardExpiryElement } from '@stripe/react-stripe-js';
import { StripeCardExpiryElementChangeEvent } from '@stripe/stripe-js';
import React from 'react';
import BaseStripeCardInput from './BaseStripeCardInput';
import { getStripeElementStyles } from './stripeStyles';

interface CardExpiryInputProps {
  disabled?: boolean;
  error?: string;
  onError?: (error: string | undefined) => void;
  onComplete?: (complete: boolean) => void;
  label?: string;
  withAsterisk?: boolean;
}

const CardExpiryInput: React.FC<CardExpiryInputProps> = ({
  disabled = false,
  error,
  onError,
  onComplete,
  label = 'Expiry Date',
  withAsterisk = false,
}) => {
  const handleChange = (event: StripeCardExpiryElementChangeEvent) => {
    if (onError) {
      onError(event.error?.message);
    }
    if (onComplete) {
      onComplete(event.complete);
    }
  };

  return (
    <BaseStripeCardInput
      label={label}
      withAsterisk={withAsterisk}
      disabled={disabled}
      error={error}
      icon={faCalendar}
    >
      <CardExpiryElement
        options={{
          placeholder: 'MM/YY',
          disabled,
          style: getStripeElementStyles(disabled),
        }}
        onChange={handleChange}
      />
    </BaseStripeCardInput>
  );
};

export default CardExpiryInput;
